import * as Sentry from "@sentry/vue";

const SentryService = {
  sentry: null,
  init(app, router) {
    if (!process.env.VUE_APP_SENTRY) {
      // eslint-disable-next-line no-console
      return console.log("[SENTRY] Sentry is disabled");
    }

    const sentryConfig = {
      app,
      dsn: process.env.VUE_APP_SENTRY,
      integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/olaii\.com\/api/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while
      // in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate
      // to 100% when sampling sessions where errors occur.
    };

    SentryService.sentry = Sentry.init(sentryConfig);
    return SentryService.sentry;
  },
};

export default SentryService;
